export function abbreviate(s, length) {
    return `${s?.slice(0, length)} ${s?.length > length ? '...' : ''}`;
}
